import $ from "jquery";
import * as React from "react";
import { Link } from "react-router-dom";
import CONSTANT from "./../../constant";

class AdminHeader extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isExpanded: true,
      openSubmenus: "",
    };
  }

  toggleMenu = () => {
    this.setState({ isExpanded: !this.state.isExpanded, openSubmenus: "" });
  };

  componentDidMount() {
    // $('.left-menu').height(document.body.scrollHeight);
    $(".left-menu").height(window.outerHeight);
  }

  render() {
    const { isExpanded } = this.state;
    return (
      <div className="flex h-screen left-menu">
        <div
          className={`transition-all duration-500 ease-in-out ${
            isExpanded ? "w-64" : "w-20"
          } flex flex-col shadow-xl`}
        >
          <div className="p-2 flex items-center justify-between">
            {isExpanded && (
              <h2 className="text-xl font-bold whitespace-nowrap text-white pl-4">
                Admin Menu
              </h2>
            )}
            <button
              onClick={this.toggleMenu}
              className={`p-2 rounded-lg hover:bg-blue-900 transition-colors ${isExpanded ? 'mx-right' : 'mx-auto'} text-white`}
            >
              {isExpanded ? (
                <i className="fa fa-times text-xl"></i>
              ) : (
                <i className="fa fa-bars text-xl"></i>
              )}
            </button>
          </div>
          <div className="navbar navbar-expand-lg p-0">
            <div className="w-100">
              <ul>
              <li>
                <Link to={CONSTANT.component.adminUserList.url}>
                  <i className="fa fa-users" /> {isExpanded && "Users"}
                </Link>
              </li>
              {/* <li>
                <Link to={CONSTANT.component.adminDepartmentList.url}>
                  <i className="fa fa-building" /> {isExpanded && "Department"}
                </Link>
              </li>
              <li>
                <Link to={CONSTANT.component.adminDesignationList.url}>
                  <i className="fa fa-certificate" />{" "}
                  {isExpanded && "Designation"}
                </Link>
              </li>
              <li>
                <Link to={CONSTANT.component.adminGradeList.url}>
                  <i className="fa fa-level-up" /> {isExpanded && "Grade"}
                </Link>
              </li>
              <li>
                <Link to={CONSTANT.component.adminGroupList.url}>
                  <i className="fa fa-group" /> {isExpanded && "Group"}
                </Link>
              </li>
              <li>
                <Link to={CONSTANT.component.adminUnitList.url}>
                  <i className="fa fa-cubes" /> {isExpanded && "Unit"}
                </Link>
              </li>
              <li>
                <Link to={CONSTANT.component.adminNoting.url}>
                  <i className="fa fa-pencil-square" /> {isExpanded && "Noting"}
                </Link>
              </li>
              <li>
                <Link to={CONSTANT.component.adminDak.url}>
                  <i className="fa fa-file" /> {isExpanded && "Dak"}
                </Link>
              </li>
              <li>
                <Link to={CONSTANT.component.adminPrintLog.url}>
                  <i className="fa fa-print" /> {isExpanded && "Print Log"}
                </Link>
              </li> */}
              <li>
                <Link to={CONSTANT.component.userFileList.url}>
                  <i className="fa fa-bars" /> {isExpanded && "Main Menu"}
                </Link>
              </li>
            </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminHeader;
